module.exports = __webpack_public_path__ + "img/icon_chess_heightlight.64811df5.png";